import React, { useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Col, Input, Label, Row, FormFeedback } from 'reactstrap';
import InputOptions from './InputOptions';
import { labelMapping } from '../../utils/constants';

const SelectControlled = ({ name, rules, options = [] }) => {
  const {
    control,
    setValue,
    formState: { defaultValues, errors },
  } = useFormContext();
  const { field } = useController({ name, control, rules });
  const value = field?.value?.value;
  const textLabel = name.split('.').pop();
  const errorMessage = name
    .split('.')
    .reduce((acc, key) => (acc ? acc[key] : undefined), errors)?.message;

  useEffect(() => {
    if (!field.value) {
      setValue(name, {});
    }
  }, [defaultValues]);

  if (!field.value) {
    return null;
  }

  return (
    <Row>
      <Label column="true" sm="3">
        {labelMapping[textLabel]}
      </Label>
      <Col sm="9">
        <Input
          type="select"
          {...field}
          value={value ?? ''}
          invalid={Boolean(errorMessage)}
          onChange={(e) =>
            field.onChange({
              ...field?.value,
              value: e.target?.value.toUpperCase(),
            })
          }
        >
          <InputOptions options={options} />
        </Input>
        {errorMessage && <FormFeedback>{errorMessage}</FormFeedback>}
      </Col>
    </Row>
  );
};

export default SelectControlled;
